import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context/BreadcrumbsContext';
import { Error404 } from '../ErrorPages';
import { StripeDashboard, StripeTerms } from './pages';

export const StripeEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Stripe',
      element: <StripeDashboard />,
      path: '/',
      index: true,
    },
    {
      label: 'Regulamin płatności',
      element: <StripeTerms />,
      path: '/terms',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return <Fragment key="routes">{routes}</Fragment>;
};
